import { Component, OnInit, ViewChild } from '@angular/core';
import {GTopicService } from './g-topic.service';
import { GeneralComponent } from './g.component';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { NgModel, NgForm } from '@angular/forms';

/** Needed to add the optional functions */
export interface GeneralTeacherComponent extends GeneralComponent {

  generate?();
}

export abstract class GeneralTeacherComponent extends GeneralComponent implements OnInit {


  @ViewChild('definitionForm') public definitionForm: NgForm;

  protected configuration: any;
  title: string;
  description: string;
  id: number;
  protected typespecs: any;
  public type: string;


  constructor(protected topicService: GTopicService, protected activatedRoute: ActivatedRoute) {
    super(topicService);
  }

  /**
   * performs some inititalizations
   */
  ngOnInit() {
    this.topicService.registerTeacherExerise(this);
    if (this.activatedRoute.snapshot.paramMap.has('id')) {
      this.id = +this.activatedRoute.snapshot.paramMap.get('id');
      this.setInformationWithConfiguration();
    }
  }

  /** adds the configuration to the exercises */
  saveExercise() {
    const definition = this.generateDefinition();
    this.topicService.addExercise(definition);

  }

  /** adds the given configuration at the right place */
  add() {
    const definition = this.generateDefinition();
    this.topicService.addExercise(definition);
  }

  /** updates the definition of this exercise or exercise set */
  update() {
    const definition = this.generateDefinition();
    this.topicService.updateExercise(definition);
    this.topicService.resetStateByKey(definition.key);
  }

  abstract generateDefinition();

  /** sets the properties based on the given configuration */
  setInformationWithConfiguration() {
    this.configuration = this.topicService.getExerciseById(this.id);
    this.title = this.configuration.title;
    this.description = this.configuration.description;
  }

  /** resets the properties to a new exercise */
  reset() {
    // this.definitionForm.reset();
    this.title = '';
    this.description = '';
    this.id = undefined;
    this.configuration = undefined;
    this.typespecs = undefined;
  }

  /** returns the topic key */
  chapterType(): string {
    return this.topicService.type;
  }

}
